// menu-items/pages.js
import { UserOutlined, ClockCircleOutlined, ProfileOutlined, OrderedListOutlined } from '@ant-design/icons';

const pages = {
  id: 'account-pages',
  title: 'Account Pages',
  type: 'group',
  children: [
    {
      id: 'whitelist',
      title: 'Whitelist',
      type: 'item',
      url: '/whitelist',
      icon: OrderedListOutlined,
      roles: ['admin'] // cuma admin
    },
    {
      id: 'profile',
      title: 'Profile',
      type: 'item',
      url: '/profile',
      icon: ProfileOutlined,
      roles: ['admin'] // cuma admin
    },
    {
      id: 'account',
      title: 'Account',
      type: 'item',
      url: '/account',
      icon: UserOutlined,
      roles: ['admin', 'user']
    },
    {
      id: 'log',
      title: 'Log',
      type: 'item',
      url: '/log',
      icon: ClockCircleOutlined,
      roles: ['admin', 'user']
    }
  ]
};

export default pages;
